
<j-flow-branch-link
    ref="root"
    :configs="linkConfigs"
    :from="configs.from.source"
    :to="configs.to.source">
</j-flow-branch-link>
